import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const VehicleRegNo = (props) => {
  return (
    <FormGroup controlId="vehicleRegNo">
      <Col componentClass={ControlLabel} sm={5}>
        Vehicle Reg. No.
      </Col>
      <Col sm={7}>
          <FormControl type="text" value={props.vehicleRegNo}
          autoComplete="off"
          onChange={props.handleChangeVehicleRegNo}
          onBlur={() => props.validation(true)} />
      </Col>
    </FormGroup>
  )
}

VehicleRegNo.propTypes = {
  vehicleRegNo: PropTypes.string,
  handleChangeVehicleRegNo: PropTypes.func,
  validation: PropTypes.func
};

export default VehicleRegNo;



// WEBPACK FOOTER //
// ./src/app/components/vehicleRegNo/VehicleRegNo.js